import React from "react"
import Layout from "components/layout"
import SEO from "components/seo"
import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from "react-helmet"

import { SectionTeasers } from "components/SectionTeasers"
import { TestimonialCarousel } from "components/TestimonialCarousel"
import { TeaserCarousel } from "components/TeaserCarousel"
import { HomeBigTeasers } from "components/HomeBigTeasers"
import { AcknoledgementStatement } from "../../components/AcknoledgementStatement"

const IndexPage = ({ pageContext }) => {
  const {
    title,
    subsiteFooter,
    excerpt,
    featuredImage,
    previewSQ,
    homeSettings,
  } = pageContext
  const homeData = useStaticQuery(graphql`
    {
      wpgraphql {
        pages(
          where: {
            nameIn: ["study", "work", "business", "live", "visit"]
            orderby: { field: MENU_ORDER, order: ASC }
          }
        ) {
          nodes {
            title
            link
            excerpt
            featuredImage {
              srcSet
              sourceUrl
              mediaDetails {
                height
                width
              }
            }
            header {
              customTitle
            }
            subsiteSettings {
              external {
                isActive
                url
              }
            }
            slug
          }
        }
      }
    }
  `)

  const filteredItems = homeData.wpgraphql.pages.nodes

  return (
    <Layout
      home
      preview={previewSQ}
      headerTitle="Canberra"
      headerText={homeSettings.introStatement || excerpt}
      headerImg={featuredImage}
      bottomSection={subsiteFooter}
    >
      <AcknoledgementStatement />
      <Helmet>
        <html className="home" />
      </Helmet>
      <SEO title="Welcome to Canberra" custom />
      <SectionTeasers home preview={previewSQ} />
      <TestimonialCarousel preview={previewSQ} />
      <HomeBigTeasers homeData={filteredItems} preview={previewSQ} />
      <TeaserCarousel content={pageContext} />
    </Layout>
  )
}

export default IndexPage
